"use client";

import { CheckCircle2 } from "@/components/icons";
import type { Id } from "@convex/_generated/dataModel";
import type { AccountType } from "@/lib/auth/types";
import { useActivityFeed } from "./use-activity-feed";
import { ActivityFeedList } from "./ActivityFeedList";

interface ActivityPanelProps {
  companyId?: Id<"companies">;
  accountTypes?: readonly AccountType[];
  onNavigate?: () => void;
}

export function ActivityPanel({
  companyId,
  accountTypes,
  onNavigate,
}: ActivityPanelProps) {
  const { items, isLoading } = useActivityFeed(companyId, accountTypes);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {isLoading ? (
        <PanelSkeleton />
      ) : items.length === 0 ? (
        <AllCaughtUp />
      ) : (
        <div className="min-h-0 flex-1 overflow-y-auto">
          <ActivityFeedList items={items} onNavigate={onNavigate} />
        </div>
      )}
    </div>
  );
}

function AllCaughtUp() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 py-12 text-center">
      <div className="mb-3 flex size-11 items-center justify-center rounded-full bg-success-bg">
        <CheckCircle2 className="size-5 text-success-strong" />
      </div>
      <p className="text-sm font-medium text-foreground">
        You&apos;re all caught up
      </p>
    </div>
  );
}

function PanelSkeleton() {
  return (
    <div className="space-y-1 py-1">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="flex items-center gap-3 px-4 py-3">
          <div className="size-9 animate-pulse rounded-md bg-muted" />
          <div className="flex-1 space-y-1.5">
            <div className="h-3.5 w-40 animate-pulse rounded-sm bg-muted" />
            <div className="h-3 w-28 animate-pulse rounded-sm bg-muted" />
          </div>
        </div>
      ))}
    </div>
  );
}
